import * as XLSX from 'xlsx';   
import { saveAs } from 'file-saver';
import * as XLSXStyle from 'xlsx-style';
export let utilTools = {}

utilTools.getBhTitle = function(process) {
    if(process.includes("L1")){
        return "县级上传报件"
    }
    else if(process.includes("L2")){
        return "市级内业审查"
    }
    else if(process.includes("L3")){
        return "内业审查反馈"
    }
    else if(process.includes("L4")){
        return "市级现场踏勘"
    }
    else if(process.includes("L5")){
        return "市级踏勘反馈"
    }
    else if(process.includes("L6")){
        return "出具踏勘报告"
    }
    else if(process.includes("L7")){
        return "补划地块入库"
    }
    else{
        return "暂无信息"
    }
 
}


// 导出
// 导出工具(按照原来的基础上修改)(JSONData--表主体, FileName--生成的excel名称, title--表头（自己写）, order = []-值与列对应的key, filter--过滤行（可不写）,needIndex--是否要序号)
//foot--表尾样式（可不写）
utilTools.JSONToExcelConvertor2=function(
        JSONData,
        FileName,
        title,
        order = [],
        filter,
        needIndex,
        foot
        ) {
        if (!JSONData) return;
        //转化json为object
        var arrData =
            typeof JSONData != "object" ? JSON.parse(JSONData) : JSONData;
        var excel = `<table border=1 >`;

        excel += title;

        // 表格主体
        //设置数据
        if (needIndex) {
            for (var i = 0; i < arrData.length; i++) {
            var row =
                "<tr style='font-size:16px;'><td align='center'>" +
                Number(i + 1) +
                "</td>";
            for (let index = 0; index < order.length; index++) {
                //判断是否有过滤行
                if (filter) {
                if (filter.indexOf(order[index]) == -1) {
                    var value =
                    arrData[i][order[index]] == null
                        ? ""
                        : arrData[i][order[index]];
                    row += "<td>" + value + "</td>";
                }
                } else {
                var value =
                    arrData[i][order[index]] == null
                    ? ""
                    : arrData[i][order[index]];
                row += "<td align='center'>" + value + "</td>";
                }
            }

            excel += row + "</tr>";
            }
        } else {
            for (var i = 0; i < arrData.length; i++) {
            var row = "<tr style='font-size:16px;'>";
            for (let index = 0; index < order.length; index++) {
                //判断是否有过滤行
                if (filter) {
                if (filter.indexOf(order[index]) == -1) {
                    var value =
                    arrData[i][order[index]] == null
                        ? ""
                        : arrData[i][order[index]];
                    row += "<td>" + value + "</td>";
                }
                } else {
                var value =
                    arrData[i][order[index]] == null
                    ? ""
                    : arrData[i][order[index]];
                row += "<td align='center'>" + value + "</td>";
                }
            }

            excel += row + "</tr>";
            }
        }
        if (foot) {
            excel += foot;
        }

        excel += "</table>";

        var excelFile =
            "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:x='urn:schemas-microsoft-com:office:excel' xmlns='http://www.w3.org/TR/REC-html40'>";
        excelFile +=
            '<meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8">';
        excelFile +=
            '<meta http-equiv="content-type" content="application/vnd.ms-excel';
        excelFile += '; charset=UTF-8">';
        excelFile += "<head>";
        excelFile += "<!--[if gte mso 9]>";
        excelFile += "<xml>";
        excelFile += "<x:ExcelWorkbook>";
        excelFile += "<x:ExcelWorksheets>";
        excelFile += "<x:ExcelWorksheet>";
        excelFile += "<x:Name>";
        excelFile += "{worksheet}";
        excelFile += "</x:Name>";
        excelFile += "<x:WorksheetOptions>";
        excelFile += "<x:DisplayGridlines/>";
        excelFile += "</x:WorksheetOptions>";
        excelFile += "</x:ExcelWorksheet>";
        excelFile += "</x:ExcelWorksheets>";
        excelFile += "</x:ExcelWorkbook>";
        excelFile += "</xml>";
        excelFile += "<![endif]-->";
        excelFile += "</head>";
        // excelFile+=`
        //     <style>
        //     th{
        //         width:200px;
        //         font-weight:400;
        //     }

        //     </style>
        // `;
        excelFile += "<body>";
        excelFile += excel;
        excelFile += "</body>";
        excelFile += "</html>";

        var uri =
            "data:application/vnd.ms-excel;charset=utf-8," +
            encodeURIComponent(excelFile);

        var link = document.createElement("a");
        link.href = uri;

        link.style = "visibility:hidden";
        link.download = FileName + ".xls";

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        }
// 日期转化
utilTools.getDate=function(sjc){
    if(sjc==null||sjc==""||sjc==undefined){
        return "";
    }else{
        let year=new Date(sjc).getFullYear()
        let month=Number(new Date(sjc).getMonth())+1
        let day=new Date(sjc).getDate()
    
        return `${year}-${month}-${day}`
    }
    
}
  //判断撤回按钮是否出现？(role:权限，process：当前流程)
utilTools.showBackButton=function(role){
    let isShow=false;
    if (role==1){
        switch(process){
            case "L100":
                isShow=false;
            case "L101":
                isShow=false;
            case "L102":
                isShow=false;
            case "L103":
                isShow=false;
            case "L300":
                isShow=true;
            case "L500":
                isShow=true;
            case "L700":
                break;
        }

    }else{
        switch(process){
            case "L100":
                isShow=false;
            case "L101":
                isShow=true;
            case "L102":
                isShow=true;
            case "L103":
                isShow=true;
            case "L300":
                isShow=false;
            case "L500":
                isShow=false;
            case "L700":
                break;
        }
    }
    
    return isShow;


}

utilTools.checkProperties=function(obj, filters = []){
    return Object.entries(obj)
    .filter(([key, value]) => 
      !filters.includes(key) && (value === null || value === "" || value === undefined)
    )
    .map(([key, value]) => key);
}
utilTools.downloadFromUrl=function(url, fileName, type,token) {
    console.log("..")
    // url:http://60.191.110.206:48001/mp-server/view/test.pdf
    const urlStr = url.replace(/\\/g, "/");
    const xhr = new XMLHttpRequest();
    xhr.open("GET", urlStr, true);
    xhr.setRequestHeader("Authorization", `Bearer ${token}`);
    xhr.responseType = "blob";
    xhr.onload = () => {
      console.log("xhr==", xhr)
      if (xhr.status === 200) {
        if (type == "download") {
          this.saveAs(xhr.response, fileName);
        } else {
          this.openAs(xhr.response, fileName);
        }

      }
    };
    xhr.send();
  }
  utilTools.saveAs=function(blob, filename) {
    if (window.navigator.msSaveOrOpenBlob) {
      navigator.msSaveBlob(blob, filename);
    } else {
      let link = document.createElement('a');
      let body = document.querySelector('body');
      link.href = window.URL.createObjectURL(blob);
      link.download = filename;
      // fix Firefox
      link.style.display = 'none';
      body.appendChild(link);
      link.click();
      body.removeChild(link);
      window.URL.revokeObjectURL(link.href);
    };

  }
  utilTools.openAs=function(blob, filename) {
     
    if (window.navigator.msSaveOrOpenBlob) {
      navigator.msSaveBlob(blob, filename);
    } else {
      let link = document.createElement('a');
      let body = document.querySelector('body');
      link.href = window.URL.createObjectURL(blob);
      link.target = "_blank"
      // link.download = filename;
      link.style.display = 'none';
      body.appendChild(link);
      // 解开注释会打开两次
      // link.click();
      body.removeChild(link);
      window.open(link.href);
    }
    ;

  }

   utilTools.fetchImageAsBase64=async function(url, token) {
    const response = await fetch(url, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
    
      const blob = await response.blob();
      const reader = new FileReader();
    
      return new Promise((resolve, reject) => {
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
  }


//   修改时间（当前时间字符串，提前或延后的天数）正数则是延后，负数就是提前
utilTools.adjustDate=function (dateString, days) {
    // 将字符串转换为 Date 对象
    const date = new Date(dateString);
  
    // 检查日期是否有效
    if (isNaN(date.getTime())) {
      throw new Error('Invalid date format');
    }
  
    // 根据第二个参数调整日期
    date.setDate(date.getDate() + days);
  
    // 格式化为 yyyy-mm-dd
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
  
    return `${year}-${month}-${day}`;
  }
// 生成缴费日期（合同起始日，合同到期日，间隔<按月，按季，按半年，按年>）会自动根据每个月最后一天，如1.31，2.28，4.30等动态设置最后一天
utilTools.randBetweenMonths = function (startDate, endDate, betweenMonths) {
  const result = [];
  let currentDate = new Date(startDate);
  const end = new Date(endDate);

  // 检查日期是否有效
  if (isNaN(currentDate.getTime()) || isNaN(end.getTime())) {
    throw new Error('Invalid date format');
  }

  while (currentDate <= end) {
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');

    // 添加格式化的日期字符串到结果数组
    result.push(`${year}-${month}-${day}`);

    // 增加月份
    const originalDay = currentDate.getDate();
    currentDate.setMonth(currentDate.getMonth() + betweenMonths);

    // 检查是否需要调整日期为月末
    if (originalDay > 28) {
      const lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0).getDate();
      if (currentDate.getDate() !== originalDay) {
        currentDate.setDate(lastDayOfMonth);
      }
    }
  }

  return result;
}

// 日期比较
  utilTools.compareDates=function (date1, date2) {
    console.log("date1==",date1)
    console.log("date2==",date2)
    const parsedDate1 = new Date(date1);
    const parsedDate2 = new Date(date2);
  
    if (isNaN(parsedDate1.getTime()) || isNaN(parsedDate2.getTime())) {
      throw new Error('Invalid date format');
    }
  
    return parsedDate1 > parsedDate2;
  }
//   修改月份（当前日期，月份数字）
utilTools.adjustDateByMonths=function (dateString, month) {
  console.log("dateString==",dateString)
  console.log("month==",month)
    const date = new Date(dateString);
    console.log("date==",date)
    // 检查日期是否有效
    if (isNaN(date.getTime())) {
      throw new Error('Invalid date format');
    }
  
    // 调整月份
    date.setMonth(date.getMonth() + month);
  
    // 格式化为 yyyy-mm-dd
    const year = date.getFullYear();
    const adjustedMonth = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
  
    return `${year}-${adjustedMonth}-${day}`;
  } 

  utilTools.MoD=function (number, divisor) {
    if (divisor === 0) {
      throw new Error('Divisor cannot be zero');
    }
  
    const remainder = number % divisor;
    return remainder >= 0 ? remainder : remainder + Math.abs(divisor);
  }

//   使用XLSX导出
/**
 * 导出 Excel 文件
 * @param {Array} header - 表头（显示名称），如 ['姓名', '年龄']
 * @param {Array} data - 数据源（JSON 数组）
 * @param {Array} headerData - 数据字段顺序，如 ['name', 'age']
 * @param {String} name - 导出文件名（不含 .xlsx）
 */
// utilTools.exportToExcel= function (header, data, headerData, name = 'export') {
//     const formattedData = data.map(item => {
//         const row = {};
//         headerData.forEach(key => {
//           row[key] = String(item[key] || '').replace(/\n/g, '\r\n');
//         });
//         return row;
//       });
    
//       const ws = XLSX.utils.json_to_sheet(formattedData, { header: headerData, skipHeader: true });
    
//       XLSX.utils.sheet_add_aoa(ws, [header], { origin: 'A1' });
//       const headerStyle = {
//         font: { bold: true },
//         fill: { fgColor: { rgb: "F0F0F0" } },
//         alignment: { horizontal: 'center', vertical: 'center', wrapText: true },
//       };
//       Object.keys(ws).forEach(key => {
//         if (/^[A-Z]1$/.test(key)) ws[key].s = headerStyle;
//       });
    
//       ws['!cols'] = headerData.map(key => {
//         const dataLengths = data.map(item => String(item[key] || '').length);
//         const contentLength = Math.max(header[headerData.indexOf(key)]?.length || 0, ...dataLengths);
//         const width = Math.min(Math.max(contentLength * 8 + 10, 50), 200);
//         return { wpx: width };
//       });
    
//       const dataStyle = { alignment: { horizontal: 'center', vertical: 'center', wrapText: true } };
//       const range = XLSX.utils.decode_range(ws['!ref']);
//       for (let r = range.s.r + 1; r <= range.e.r; r++) {
//         for (let c = range.s.c; c <= range.e.c; c++) {
//           const cell = ws[XLSX.utils.encode_cell({ r, c })];
//           if (cell) cell.s = dataStyle;
//         }
//       }
    
//       const wb = XLSX.utils.book_new();
//       XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
//       const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
//       saveAs(new Blob([excelBuffer], { type: 'application/octet-stream' }), `${name}.xlsx`);
//   utilTools.exportToExcel= function (header, data, headerData, name = 'export')}
utilTools.exportToExcel= function (header, data, headerData, name = 'export'){
// 1. 数据预处理（换行符转换）
const formattedData = data.map(item => {
    const row = {};
    headerData.forEach(key => {
      row[key] = String(item[key] || '').replace(/\n/g, '\r\n');
    });
    return row;
  });

  // 2. 创建工作表
  const ws = XLSX.utils.json_to_sheet(formattedData, {
    header: headerData,
    skipHeader: true,
  });

  // 3. 替换表头并设置标题行样式
  XLSX.utils.sheet_add_aoa(ws, [header], { origin: 'A1' });

  // 4. 设置样式
  const headerStyle = {
    font: { bold: true, sz: 12 },
    fill: { fgColor: { rgb: "F0F0F0" } },
    alignment: { horizontal: 'center', vertical: 'center', wrapText: true },
  };
  const dataStyle = {
    alignment: { horizontal: 'center', vertical: 'center', wrapText: true },
  };

  // 应用标题行样式
  Object.keys(ws).forEach(key => {
    if (/^[A-Z]1$/.test(key)) {
      ws[key].s = headerStyle;
    } else if (key !== '!ref' && key !== '!cols') {
      ws[key].s = dataStyle;
    }
  });

  // 5. 设置列宽（最小50，最大200）
  ws['!cols'] = headerData.map(key => {
    const maxContentLength = Math.max(
      header[headerData.indexOf(key)]?.length || 0,
      ...data.map(item => String(item[key] || '').length)
    );
    const width = '150'; // 估算宽度
    return { wpx: width };
  });

 // 6. 导出文件（修改为使用 'binary' 类型）
 //       const wb = XLSX.utils.book_new();
 const wb = XLSX.utils.book_new();
XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
const excelBuffer = XLSXStyle.write(wb, {
    bookType: 'xlsx',
    type: 'binary', // ✅ 改用 binary
    bookSST: false,
  });
  // 将 binary 转换为 Blob
  const blob = new Blob([s2ab(excelBuffer)], { type: 'application/octet-stream' });
  saveAs(blob, `${name}.xlsx`);
  
  // 辅助函数：字符串转 ArrayBuffer
  function s2ab(s) {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
    return buf;
  }

}